import { CalendarExportContants } from '@therealmanage/ciranet-ui-common';

export class CalendarEvent {
  uid: string;
  title: string;
  description: string;
  createdDate: string;
  createdBy: { name?: string; email?: string };
  startDate: string;
  endDate: string;
  status: 'BUSY' | 'FREE';
  rrule: string;
  exdate: string;
  allDay: boolean;
  timezone: string;

  toEventString(): string {
    const items: string[] = [];

    items.push(CalendarExportContants.BEGIN_EVENT);
    items.push(CalendarExportContants.UID(this.uid));
    items.push(CalendarExportContants.SUMMARY(this.title));
    items.push(CalendarExportContants.DESCRIPTION(this.description));
    items.push(CalendarExportContants.DTSTAMP(this.createdDate, this.timezone));
    items.push(CalendarExportContants.DTSTART(this.startDate, this.timezone));
    items.push(CalendarExportContants.DTEND(this.endDate, this.timezone));
    items.push(CalendarExportContants.STATUS(this.status));
    items.push(CalendarExportContants.ORGANIZER(this.createdBy));
    if (!!this.rrule) {
      items.push(CalendarExportContants.RRULE(this.rrule));
    }
    if (!!this.exdate) {
      items.push(CalendarExportContants.EXDATE(this.exdate));
    }
    items.push(CalendarExportContants.END_EVENT);

    return items.join(CalendarExportContants.NEW_LINE);
  }
}
